import GLightbox from 'glightbox';

let galleryLightbox = null;
let videoLightbox = null;

export function initGLightBox() {
    galleryLightbox = GLightbox({
        selector: '.gallery-item',
    });

    videoLightbox = GLightbox({
        selector: '.video-item',
    });

    return { lightbox: galleryLightbox, videoLightbox };
}

export function reloadGalleryLightbox() {
    if (galleryLightbox) {
        galleryLightbox.reload();
    }
}
